import { Descriptions } from 'antd';
import React from 'react';
import SkeletonInput from 'antd/lib/skeleton/Input';

const PurchaseRequestLoadingView = ({ active }: { active: boolean }) => {
  return (
    <>
      <Descriptions title="Purchase Request">
        <Descriptions.Item label="Code">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Required Date">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Source Document">
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Destination" span={2}>
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Notes" span={2}>
          <SkeletonInput active={active} />
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <SkeletonInput active={active} />
        </Descriptions.Item>
      </Descriptions>
    </>
  );
};
export default PurchaseRequestLoadingView;
